(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('novli-cart-drawer')) {
      return;
    }

    class NovliCartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.abortController = new AbortController();

        const signal = this.abortController.signal;

        this.addEventListener(
          'click',
          this.handleClick.bind(this),
          { signal }
        );

        this.dialog?.addEventListener(
          'click',
          this.handleBackdrop.bind(this),
          { signal }
        );

        this.dialog?.addEventListener(
          'close',
          this.unlockPage.bind(this),
          { signal }
        );

        this.startTimer();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearInterval(this.timerInterval);
      }

      open() {
        if (!this.dialog) {
          return;
        }

        if (!this.dialog.open) {
          this.dialog.showModal();
        }

        document.documentElement.style.overflow = 'hidden';

        this.querySelector('[data-nv-close]')?.focus({
          preventScroll: true
        });

        this.startTimer();
      }

      close() {
        if (this.dialog?.open) {
          this.dialog.close();
        }
      }

      unlockPage() {
        document.documentElement.style.removeProperty(
          'overflow'
        );
      }

      handleBackdrop(event) {
        if (event.target === this.dialog) {
          this.close();
        }
      }

      handleClick(event) {
        const closeButton =
          event.target.closest('[data-nv-close]');

        if (closeButton) {
          this.close();
          return;
        }

        const lineItem =
          event.target.closest('[data-nv-line-item]');

        if (!lineItem) {
          return;
        }

        const line =
          Number(lineItem.dataset.line);

        const quantity =
          Number(
            lineItem
              .querySelector(
                '.nv-cart-item__quantity span'
              )
              ?.textContent || 1
          );

        if (event.target.closest('[data-nv-remove]')) {
          this.changeLine(line, 0);
          return;
        }

        const quantityButton =
          event.target.closest('[data-nv-quantity]');

        if (!quantityButton) {
          return;
        }

        const nextQuantity =
          quantityButton.dataset.nvQuantity === 'increase'
            ? quantity + 1
            : Math.max(0, quantity - 1);

        this.changeLine(line, nextQuantity);
      }

      async changeLine(line, quantity) {
        if (this.dataset.loading === 'true') {
          return;
        }

        this.dataset.loading = 'true';
        this.setStatus('Updating your cart…');

        try {
          const root =
            window.Shopify?.routes?.root || '/';

          const response =
            await fetch(
              `${root}cart/change.js`,
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json',
                  Accept:
                    'application/json'
                },
                body: JSON.stringify({
                  line,
                  quantity,
                  sections:
                    'cart-drawer-section',
                  sections_url:
                    window.location.pathname
                })
              }
            );

          const data =
            await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              'Cart could not be updated.'
            );
          }

          const html =
            data.sections?.[
              'cart-drawer-section'
            ];

          if (!html) {
            throw new Error(
              'Cart drawer section was not returned.'
            );
          }

          const replacement =
            this.replaceFromHTML(html);

          this.updateHeaderCount(replacement);

          document.dispatchEvent(
            new CustomEvent(
              'cart:update',
              {
                bubbles: true,
                detail: {
                  cart: data
                }
              }
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true,
                detail: {
                  cart: data
                }
              }
            )
          );
        } catch (error) {
          this.dataset.loading = 'false';

          this.setStatus(
            error.message ||
            'Please try again.'
          );
        }
      }

      replaceFromHTML(html) {
        const parsed =
          new DOMParser().parseFromString(
            html,
            'text/html'
          );

        const replacement =
          parsed.querySelector(
            'novli-cart-drawer#cart-drawer'
          );

        if (!replacement) {
          throw new Error(
            'New cart drawer markup was not found.'
          );
        }

        this.replaceWith(replacement);

        requestAnimationFrame(() => {
          replacement.open();
        });

        return replacement;
      }

      updateHeaderCount(drawer) {
        const count =
          drawer
            .querySelector('.nv-cart__count')
            ?.textContent
            ?.trim() || '0';

        const cartIcon =
          document.querySelector('cart-icon');

        const bubbleCount =
          document.querySelector(
            '[data-testid="cart-bubble"]'
          );

        if (bubbleCount) {
          bubbleCount.textContent = count;
        }

        cartIcon?.classList.toggle(
          'header-actions__cart-icon--has-cart',
          Number(count) > 0
        );
      }

      async addSelectedPack(button) {
        if (!button || button.disabled) {
          return;
        }

        const bundle =
          button.closest('#nt-bundle-offer');

        const selectedPack =
          bundle?.querySelector(
            '.nt-pack--selected'
          );

        const variantId =
          selectedPack?.dataset.variant ||
          bundle?.dataset.packOne;

        if (!variantId) {
          this.setStatus(
            'Please select a pack.'
          );

          return;
        }

        const originalText =
          button.textContent.trim() ||
          'ADD TO CART';

        button.disabled = true;
        button.classList.add('nt-loading');
        button.textContent = 'ADDING…';

        try {
          const root =
            window.Shopify?.routes?.root || '/';

          const response =
            await fetch(
              `${root}cart/add.js`,
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json',
                  Accept:
                    'application/json'
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: Number(variantId),
                      quantity: 1
                    }
                  ],
                  sections:
                    'cart-drawer-section',
                  sections_url:
                    window.location.pathname
                })
              }
            );

          const data =
            await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              'The item could not be added.'
            );
          }

          const html =
            data.sections?.[
              'cart-drawer-section'
            ];

          if (!html) {
            throw new Error(
              'Shopify did not return the cart drawer section.'
            );
          }

          const replacement =
            this.replaceFromHTML(html);

          this.updateHeaderCount(replacement);

          document.dispatchEvent(
            new CustomEvent(
              'cart:update',
              {
                bubbles: true,
                detail: {
                  cart: data
                }
              }
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true,
                detail: {
                  cart: data
                }
              }
            )
          );

          button.textContent = 'ADDED ✓';

          window.setTimeout(() => {
            button.disabled = false;

            button.classList.remove(
              'nt-loading'
            );

            button.textContent =
              originalText;
          }, 1300);
        } catch (error) {
          button.disabled = false;

          button.classList.remove(
            'nt-loading'
          );

          button.textContent =
            'TRY AGAIN';

          this.setStatus(
            error.message ||
            'Please try again.'
          );

          window.setTimeout(() => {
            button.textContent =
              originalText;
          }, 1800);
        }
      }

      setStatus(message) {
        const status =
          this.querySelector(
            '[data-nv-status]'
          );

        if (status) {
          status.textContent = message;
        }
      }

      startTimer() {
        const output =
          this.querySelector(
            '[data-nv-timer]'
          );

        if (!output) {
          return;
        }

        const duration =
          10 * 60 * 1000;

        const storageKey =
          'novli-checkout-timer-end';

        let end =
          Number(
            sessionStorage.getItem(
              storageKey
            )
          );

        if (!end || end <= Date.now()) {
          end =
            Date.now() + duration;

          sessionStorage.setItem(
            storageKey,
            String(end)
          );
        }

        const tick = () => {
          let remaining =
            end - Date.now();

          if (remaining <= 0) {
            end =
              Date.now() + duration;

            sessionStorage.setItem(
              storageKey,
              String(end)
            );

            remaining = duration;
          }

          const totalSeconds =
            Math.max(
              0,
              Math.ceil(
                remaining / 1000
              )
            );

          const minutes =
            Math.floor(
              totalSeconds / 60
            );

          const seconds =
            totalSeconds % 60;

          output.textContent =
            `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        };

        window.clearInterval(
          this.timerInterval
        );

        tick();

        this.timerInterval =
          window.setInterval(
            tick,
            1000
          );
      }
    }

    customElements.define(
      'novli-cart-drawer',
      NovliCartDrawer
    );

    document.addEventListener(
      'click',
      (event) => {
        const addButton =
          event.target.closest(
            '[data-nt-bundle-cart]'
          );

        if (!addButton) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const drawer =
          document.querySelector(
            'novli-cart-drawer#cart-drawer'
          );

        drawer?.addSelectedPack(
          addButton
        );
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const cartTrigger =
          event.target.closest(
            '[data-nv-open-cart], [data-testid="cart-drawer-trigger"], a[href$="/cart"]'
          );

        if (
          !cartTrigger ||
          event.defaultPrevented ||
          cartTrigger.closest(
            'novli-cart-drawer'
          )
        ) {
          return;
        }

        const drawer =
          document.querySelector(
            'novli-cart-drawer#cart-drawer'
          );

        if (!drawer) {
          return;
        }

        event.preventDefault();
        drawer.open();
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
